module.exports = "img/slide3.6184df.jpeg";